import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { BottomSheet } from '../../weekly/v2/primitives/BottomSheet';
import { ReviewFlow } from '../ReviewFlow';
import { selectPantrySnapshot } from '../../../redux/pantrySelectors';
import { updateItemAndSync } from '../../../redux/inventorySlice';
import { markPantryUpdated } from '../../../redux/pantrySyncSlice';
import { buildKeepFiveUpdates } from '../usePantryActions';
import { usePantryToast } from '../PantryToast';
import { trackEvent } from '../../../services/analyticsService';
import { Paprika } from '../../../styles/theme';
import { RootState, AppDispatch } from '../../../redux/store';

interface ReviewSheetProps {
  visible: boolean;
  onClose: () => void;
}

export function ReviewSheet({ visible, onClose }: ReviewSheetProps) {
  const snapshot = useSelector(selectPantrySnapshot);
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();
  const userId = useSelector((state: RootState) => state.auth?.user?.uid);
  const { flash } = usePantryToast();

  const handleKeep = (itemId: string) => {
    const updates = buildKeepFiveUpdates();
    dispatch(updateItemAndSync({ id: itemId, updates, userId }));
  };

  const handleToss = (itemId: string) => {
    const updates = { status: 'discarded' as const, consumedBeforeExpiry: false };
    dispatch(updateItemAndSync({ id: itemId, updates, userId }));
    // Silent toss: no individual toast
  };

  const handleDone = (reviewedCount: number) => {
    dispatch(markPantryUpdated());
    trackEvent('pantry_review_completed', { count: reviewedCount });
    flash(t('pantry.review.allDone'));
    onClose();
  };

  if (!visible) return null;

  return (
    <BottomSheet visible={visible} onClose={onClose}>
      <View style={styles.container}>
        <ReviewFlow
          list={snapshot.reviewList}
          onKeep={handleKeep}
          onToss={handleToss}
          onDone={handleDone}
        />
      </View>
    </BottomSheet>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Paprika.background,
    paddingBottom: 24,
    minHeight: 400,
  },
});
